import { render, staticRenderFns } from "./SparklEmbed.vue?vue&type=template&id=200d732a"
import script from "./SparklEmbed.vue?vue&type=script&lang=js"
export * from "./SparklEmbed.vue?vue&type=script&lang=js"
import style0 from "./SparklEmbed.vue?vue&type=style&index=0&id=200d732a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports